/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * Schema for the list of resources.
 */
export interface ListDidCommMessage {
    /** The list of resources. */
    items: Truvity.ResourceDidCommMessage[];
}
